import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import { FadedPaper } from '../../theme/StyledFields';
import KeyTakeaway from '../team-report/KeyTakeaway';
import { SessionsCompletedThresholdSection as ThresholdData } from './types';

interface Props {
    data: ThresholdData;
    totalOrganizationAthletes: number;
}

const SessionsCompletedThresholdSection: React.FC<Props> = ({ data, totalOrganizationAthletes }) => {
    const [sessionNumber, setSessionNumber] = useState<number>(1);

    const selectedRow = useMemo(
        () => data.rows.find((r) => r.session_number === sessionNumber) ?? data.rows[0],
        [data.rows, sessionNumber],
    );

    return (
        <FadedPaper sx={{ p: 3, mb: 3 }} data-testid="section-sessions-completed-threshold">
            <Typography variant="h5" sx={{ mb: 1 }}>
                Workshop session completion
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                For each session number 1–12, the percentage of all organization members ({totalOrganizationAthletes})
                who have completed least one lesson plan.
            </Typography>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Session number (N)</TableCell>
                            <TableCell align="right">Athletes who completed session N</TableCell>
                            <TableCell align="right">% of roster</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.rows.map((r) => (
                            <TableRow
                                key={r.session_number}
                                selected={r.session_number === sessionNumber}
                                sx={
                                    r.session_number === sessionNumber
                                        ? { bgcolor: 'action.selected' }
                                        : undefined
                                }
                            >
                                <TableCell>{r.session_number}</TableCell>
                                <TableCell align="right">{r.athlete_count}</TableCell>
                                <TableCell align="right">{r.percent}%</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <KeyTakeaway text={data.key_takeaway} />
        </FadedPaper>
    );
};

export default SessionsCompletedThresholdSection;
